import { Modal } from "@mantine/core";
import React from "react";

import ModalHeader from "components/ModalHeader";

import AddOrgMembersForm from "./AddOrgMermbersForm";
import { Organization } from "types";

type CreateProjectModalProps = {
  opened: boolean;
  onClose: () => void;
  org: Organization;
};

function AddOrgMembersModal({ opened, onClose, org }: CreateProjectModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Add Member"
        onClose={onClose}
        ariaLabel="Close add member modal"
      />
      <AddOrgMembersForm onClose={onClose} orgId={org._id}/>
    </Modal>
  );
}

export default AddOrgMembersModal;
